/**
 * Chinese translations
 * 中文翻译
 */

export default {
  common: {
    loading: '加载中...',
    error: '发生错误',
    retry: '重试',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    back: '返回',
    backHome: '返回首页',
    next: '下一步',
    submit: '提交',
    upload: '上传',
    download: '下载',
    send: '发送',
    or: '或',
    redirecting: '正在跳转...',
    minutes: '分钟',
    saving: '保存中...',
    refresh: '刷新',
  },
  home: {
    codePlaceholder: 'ABC123',
    join: '加入',
  },
  dashboard: {
    greetingMorning: '早上好',
    greetingAfternoon: '下午好',
    greetingEvening: '晚上好',
    subtitle: '您的工作坊会话',
    joinNew: '加入新会话',
    activeSessions: '进行中的会话',
    pastSessions: '历史会话',
    noActiveSessions: '没有进行中的会话',
    noPastSessions: '没有历史会话',
    code: '代码',
    joinedOn: '加入于',
    roleHost: '主持人',
    roleParticipant: '参与者',
    statusActive: '进行中',
    statusWaiting: '等待中',
    statusEnded: '已结束',
    archived: '已归档',
    rejoin: '重新加入',
    viewSummary: '查看总结',
  },
  auth: {
    login: '登录',
    register: '注册',
    logout: '退出登录',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    nickname: '昵称',
    enterNickname: '输入您的昵称',
    enterPassword: '输入您的密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    wechatLogin: '微信登录',
    loginWithEmail: '邮箱登录',
    noAccount: '还没有账号？',
    hasAccount: '已有账号？',
    registerNow: '立即注册',
    loginNow: '立即登录',
    profileSetup: '设置您的个人资料',
    uploadAvatar: '上传头像',
    processing: '正在处理认证...',
  },
  profile: {
    editProfile: '编辑资料',
    uploadAvatar: '上传头像',
    changeAvatar: '更换头像',
    clickToUpload: '点击上传',
    nickname: '昵称',
    nicknamePlaceholder: '输入您的昵称',
    saveProfile: '保存',
    profileSaved: '资料保存成功',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    switchLanguage: '切换语言',
    switchToHost: '切换到主持人视图',
    switchToParticipant: '切换到参与者视图',
    switchWorkshop: '切换工作坊',
    switchWorkshopHint: '离开当前工作坊并加入另一个',
    confirmLeave: '离开当前工作坊？',
    confirmLeaveHint: '您可以稍后使用相同的代码重新加入。',
    invalidImageType: '请选择图片文件',
    imageTooLarge: '图片必须小于5MB',
    avatarUploadFailed: '头像上传失败',
    saveFailed: '保存资料失败',
    anonymous: '匿名用户',
  },
  workshop: {
    joinWorkshop: '加入工作坊',
    joining: '正在加入工作坊...',
    enterCode: '输入工作坊代码',
    scanQR: '扫描二维码',
    workshop: '工作坊',
    code: '工作坊代码',
    participants: '参与者',
    teams: '团队',
    materials: '素材',
    timer: '计时器',
    agenda: '议程',
    phase: '阶段',
    phaseControl: '阶段控制',
    appearanceDescription: '描述您的外貌特征',
    appearancePlaceholder: '例如：穿蓝色衬衫，短发，戴眼镜...',
    appearanceHint: '这有助于其他人在工作坊中认出您。',
  },
  phases: {
    selfIntro: '自我介绍',
    adIntro: '口述影像介绍',
    examples: '示例视频',
    techGuide: '技术导引',
    interactive: '互动实践',
    creation: '作品创作',
    team: '组队',
    recording: '录制',
    sharing: '分享',
    wrapup: '总结',
    summary: '现场总结',
  },
  roles: {
    describer: '描述者',
    describer_desc: '用语言描述图片进行口述影像',
    aiOperator: 'AI操作者',
    aiOperator_desc: '根据搭档指导操作AI工具',
    host: '主持人',
    participant: '参与者',
  },
  team: {
    team: '团队',
    teams: '团队',
    yourTeam: '您的团队',
    teamNumber: '第 {number} 组',
    teamMaterial: '分配的素材',
    members: '团队成员',
    comments: '评论',
    addComment: '添加评论...',
    writeComment: '写评论...',
    noComments: '暂无评论',
    capturePhoto: '拍照',
    uploadPhoto: '上传照片',
    uploadVideo: '上传视频',
    uploadMedia: '上传素材',
    formation: '团队组建',
    randomize: '随机分配',
    notFormed: '团队尚未组建',
    you: '你',
    partner: '搭档',
    selectRole: '选择你的角色',
    select: '选择',
    selected: '已选择',
    partnerSelected: '搭档已选',
    roleConflict: '双方选择了相同的角色！请选择不同的角色。',
    roleConflictTitle: '角色冲突',
    swapRoles: '交换角色',
    loading: '正在加载队伍数据...',
    readyToProceed: '就绪！等待主持人开始第3阶段',
    phaseNavigation: '阶段导航',
    viewPhase: '查看阶段',
    currentPhase: '当前',
    viewingPastPhase: '正在查看过去的阶段',
    backToCurrentPhase: '返回当前阶段',
    // PhotoCapture translations / 照片拍摄翻译
    cameraNotSupported: '当前浏览器不支持摄像头功能',
    cameraPermissionDenied: '摄像头权限被拒绝。请允许访问摄像头。',
    cameraNotFound: '未找到摄像头设备',
    cameraError: '无法访问摄像头。请检查权限设置。',
    capturedPhoto: '已拍摄的照片',
    readyToCapture: '准备拍摄',
    startingCamera: '正在启动摄像头...',
    openCamera: '打开摄像头',
    retake: '重拍',
    captureHint: '拍摄团队作品的照片',
    captureError: '拍照失败',
  },
  teamManage: {
    title: '管理团队',
    editTeams: '编辑团队',
    createTeam: '新建团队',
    deleteTeam: '删除团队',
    unassigned: '未分配',
    emptyTeam: '拖放参与者到这里',
    allAssigned: '所有参与者已分配',
    dragHint: '拖动参与者在团队间移动，或点击选中后点击目标团队',
    cannotDeleteWithMembers: '无法删除有成员的团队。请先移除成员。',
  },
  qr: {
    roomCode: '房间码',
    copyCode: '复制代码',
    participants: '参与者',
    viewAll: '查看全部',
    regenerate: '重新生成',
    expiresIn: '有效期剩余 {time}',
    expired: '已过期',
    expiresInDays: '剩余 {days} 天',
    expiresInHours: '剩余 {hours} 小时',
    expiresInMinutes: '剩余 {minutes} 分钟',
    expiresInSeconds: '剩余 {seconds} 秒',
  },
  ai: {
    generation: 'AI生成',
    generateImage: '生成图片',
    generateVideo: '生成视频',
    imageDesc: '使用AI创建图片',
    videoDesc: '使用AI创建视频',
    prompt: '提示词',
    promptPlaceholder: '描述您想要生成的内容...',
    enterPrompt: '描述您想要生成的内容...',
    generating: '生成中...',
    quotaRemaining: '剩余 {count} 次',
    requestMore: '请求更多',
    quotaExhausted: '配额已用完',
    comingSoon: 'AI生成功能即将上线...',
    negativePrompt: '负面提示词',
    negativePromptHint: '描述不想出现的内容',
    negativePromptPlaceholder: '例如：低质量，模糊，水印...',
    imageSize: '图片尺寸',
    videoDuration: '视频时长',
    seconds: '秒',
    generate: '生成',
    regenerate: '重新生成',
    save: '保存',
    saved: '已保存',
    progress: '进度',
    waitingForResult: '正在生成，请稍候...',
    progressHint: '这可能需要几分钟时间...',
    generationFailed: '生成失败',
    noApiKey: '未配置API密钥',
    noApiKeyHint: '请联系主持人配置DashScope API密钥',
    configureApiKey: '配置API密钥',
    apiKeyPlaceholder: '输入DashScope API密钥',
    apiKeySaved: 'API密钥已保存',
    testApiKey: '测试连接',
    testing: '测试中...',
    testSuccess: 'API密钥有效',
    testFailed: 'API密钥无效',
    imageGallery: '图片',
    videoGallery: '视频',
    aiGenerated: 'AI生成',
    userUploaded: '用户上传',
    capturedPhoto: '拍摄的照片',
    capturedVideo: '拍摄的视频',
    deleteUploadConfirm: '确定要删除此上传内容吗？',
    deleteError: '删除失败，请重试',
    noGenerations: '暂无内容',
    noImages: '暂无图片',
    noVideos: '暂无视频',
    deleteConfirm: '确定要删除此生成结果吗？',
    comments: '评论',
    noComments: '暂无评论',
    addComment: '添加评论',
    commentPlaceholder: '写下您的评论...',
    submitComment: '发送',
    deleteCommentConfirm: '确定要删除此评论吗？',
    commentAs: '评论身份',
    preview: '预览',
  },
  host: {
    login: '主持人登录',
    loginHint: '输入工作坊代码和主持人密码',
    password: '主持人密码',
    enterPassword: '输入主持人密码',
    confirmPassword: '确认主持人密码',
    enterDashboard: '进入控制台',
    createWorkshop: '创建新工作坊',
    createWorkshopHint: '设置新的工作坊会话',
    workshopName: '工作坊名称',
    enterWorkshopName: '输入工作坊名称',
    creating: '正在创建工作坊...',
    createSuccess: '工作坊创建成功！',
    shareInfo: '分享此代码或二维码给参与者',
    copyCode: '复制代码',
    codeCopied: '代码已复制！',
    goToDashboard: '进入控制台',
    advancedSettings: '高级设置',
    teamSize: '团队人数',
    imageQuota: '每组图片配额',
    videoQuota: '每组视频配额',
    maxParticipants: '最大参与人数',
    dashboard: '主持人控制台',
    bigScreen: '大屏幕',
    startGrouping: '开始分组',
    reshuffleTeams: '重新分组',
    startTimer: '开始计时',
    pauseTimer: '暂停计时',
    resumeTimer: '继续计时',
    resetTimer: '重置计时',
    setDuration: '设置时长',
    setPhase: '设置阶段',
    uploadMaterials: '上传素材',
    endSession: '结束会话',
  },
  materials: {
    title: '素材管理',
    assigned: '分配的素材',
    notAssigned: '尚未分配素材',
    assignRandom: '随机分配',
    uploading: '上传中...',
    dropHere: '拖放文件到此处上传',
    orClick: '或点击选择文件',
    confirmDelete: '确定要删除此素材吗？',
    available: '可用',
    disabled: '已禁用',
    enable: '启用',
    disable: '禁用',
    empty: '暂无上传的素材',
    // 阶段3示例素材标签
    exampleMaterials: '示例素材',
    teamMaterials: '团队素材',
    exampleHint: '这些将在阶段3（示例视频）向参与者展示',
    teamHint: '这些将在阶段5+分配给团队进行互动实践',
  },
  phase3: {
    title: '示例视频',
    subtitle: '观看口述影像演示视频',
    noExamples: '暂无示例素材',
    followHost: '请跟随大屏幕上的演示',
    previous: '上一个',
    next: '下一个',
  },
  timer: {
    running: '计时中',
    paused: '已暂停',
    stopped: '已停止',
  },
  status: {
    online: '在线',
    offline: '离线',
  },
  summary: {
    title: '工作坊总结',
    results: '团队成果',
    timeline: '活动时间线',
    shareCard: '分享卡片',
    downloadCard: '下载分享卡片',
    shareToSocial: '分享到社交媒体',
    generateShare: '生成分享卡片',
    shareHint: '创建一张可分享的工作坊体验图片',
    noCreation: '未提交作品',
    shareComingSoon: '分享卡片生成功能即将上线！',
  },
  activity: {
    session_created: '工作坊创建',
    participant_joined: '参与者加入',
    participant_left: '参与者离开',
    phase_changed: '阶段变更',
    teams_formed: '团队组建',
    timer_started: '计时开始',
    timer_paused: '计时暂停',
    timer_reset: '计时重置',
    material_assigned: '素材分配',
    creation_submitted: '作品提交',
    session_ended: '工作坊结束',
  },
  accessibility: {
    skipToMain: '跳转到主要内容',
    toggleTheme: '切换主题',
    toggleLanguage: '切换语言',
    highContrast: '高对比度模式',
    increaseFont: '增大字体',
    decreaseFont: '减小字体',
  },
  phase2: {
    subtitle: '学习口述影像的基础知识',
    noContent: '暂无内容',
    slide: '幻灯片',
    hostControls: '阶段2控制',
    currentSlide: '当前幻灯片',
    followAlong: '请跟随大屏幕上的演示',
    definition: {
      title: '什么是口述影像？',
      text: '口述影像是一种为视障人士提供的旁白服务，描述内容中的视觉元素。它为关键视觉元素（如动作、场景、面部表情、服装和环境）提供口头描述。',
      highlight: '"口述影像将视觉内容转化为包容性体验，让媒体对每个人都无障碍。"',
    },
    scenarios: {
      title: '口述影像的应用场景',
      film: {
        name: '影视作品',
        desc: '电影、电视节目、流媒体内容',
      },
      live: {
        name: '现场活动',
        desc: '戏剧、体育、演唱会',
      },
      museum: {
        name: '博物馆与展览',
        desc: '美术馆、展览、导览',
      },
      digital: {
        name: '数字内容',
        desc: '网站、应用、社交媒体',
      },
    },
    principles: {
      title: '关键原则',
      objectivity: {
        name: '保持客观',
        desc: '描述你所看到的，而不是你的想法或感受。避免添加个人解读或情感评论。',
      },
      style: {
        name: '允许个人风格',
        desc: '在保持客观的同时，你独特的视角和词汇会自然地影响描述。这种个人风格是可以接受的，并且会增添丰富性。',
      },
      artForm: {
        name: '口述影像是一种艺术形式',
        desc: '口述影像是一种独立的艺术形式。好的描述可以像视觉内容本身一样富有创意和吸引力。',
      },
    },
    history: {
      title: '口述影像的历史',
      usOrigin: '美国起源',
      usOriginDesc: '1974年，Gregory Frazier在旧金山州立大学首创口述影像概念。',
      liveTheater: '现场演出',
      liveTheaterDesc: '1981年，Pfanstiehls夫妇在Arena Stage创建了首个现场口述影像项目。',
      dvsBirth: 'DVS诞生',
      dvsBirthDesc: '1990年，WGBH推出描述视频服务(DVS)，口述影像走向主流电视。',
      chinaStart: '中国发展',
      chinaStartDesc: '2003年红丹丹成立；2017年光明影院启动，制作800+部无障碍影片。',
    },
    humanAI: {
      title: '人与AI的协作',
      owlMetaphor: '"让AI成为你肩上的猫头鹰——辅助你变得更智慧，而不是替你思考。"',
      owlSource: '— 哈佛大学 Christopher Dede 教授',
      cognitivePartner: '认知伙伴',
      cognitivePartnerDesc: 'AI可以增强我们的描述能力，但人类的创造力和情感洞察力不可替代。',
      balanceTitle: '平衡的艺术',
      balanceDesc: '将AI作为促进成长的工具，而非依赖的拐杖。',
    },
    philosophy: {
      title: '口述影像的哲学',
      artFormTitle: '独立的艺术形式',
      artFormDesc: '口述影像不仅仅是翻译——它是一种创造性的诠释，将视觉转化为听觉体验。',
      personalStyleTitle: '个人风格',
      personalStyleDesc: '在客观描述的框架内，你独特的视角和词汇选择会自然地塑造描述。',
      emotionalTitle: '情感共鸣',
      emotionalDesc: '优秀的口述影像能够像视觉内容本身一样引发情感共鸣。',
    },
    comparison: {
      title: '对比练习',
      instruction: '比较"纯客观描述"与"自由发挥描述"的差异',
      objectiveLabel: '客观描述',
      objectivePlaceholder: '描述你所看到的事实...',
      creativeLabel: '自由描述',
      creativePlaceholder: '加入你的感受和诠释...',
      submitButton: '提交对比',
      discussPrompt: '讨论：个人经历如何影响我们的表述方式？',
    },
  },
  workshopCreate: {
    createWorkshop: '创建工作坊',
    editWorkshop: '编辑工作坊',
    createHint: '设置新工作坊，准备好后即可发布',
    basicInfo: '基本信息',
    workshopName: '工作坊名称',
    workshopNamePlaceholder: '口述影像工作坊 - 第三期',
    description: '描述',
    descriptionPlaceholder: '输入工作坊描述...',
    descriptionTooLong: '描述不能超过500个字符',
    scheduledDate: '计划日期',
    scheduledTime: '计划时间',
    participantSettings: '参与者设置',
    maxParticipants: '最大参与人数',
    participantHint: '参与者将被分成 {teams} 个组',
    advancedSettings: '高级设置',
    qrSettings: '二维码设置',
    qrExpiry: '二维码有效期',
    aiSettings: 'AI生成设置',
    imageQuotaPerTeam: '每组图片配额',
    videoQuotaPerTeam: '每组视频配额',
    estimatedUsage: '预计：{imageQuota} 图片 × {teams} 组 = {totalImage} | {videoQuota} 视频 × {teams} 组 = {totalVideo}',
    teamSettings: '组队设置',
    teamSize: '组队人数',
    people: '人',
    teamAssignment: '分组方式',
    assignment: {
      random: '随机',
      manual: '手动',
    },
    phaseDurations: '阶段时长（分钟）',
    phases: {
      lobby: '等候区',
      teams: '组队',
      aiGeneration: 'AI生成',
      creation: '创作',
      recording: '录制',
      sharing: '分享',
      wrapup: '总结',
    },
    totalDuration: '总时长',
    saveDraft: '保存草稿',
    publish: '发布工作坊',
    publishing: '发布中...',
    setPassword: '设置主持人密码',
    passwordHint: '设置密码以便主持人访问工作坊控制台',
    passwordTooShort: '密码至少需要4个字符',
    confirmPublish: '发布',
    publishSuccess: '工作坊已发布！',
    shareInfo: '分享此代码或二维码给参与者',
  },
  lobby: {
    yourIntro: '您的介绍',
    otherParticipants: '其他参与者',
    textIntroLabel: '或输入您的介绍',
    textIntroPlaceholder: '介绍一下您自己...',
    noOtherParticipants: '暂无其他参与者',
    completeIntroToContinue: '完成您的介绍以继续',
    waitingForHost: '等待主持人进行分组...',
    participantsCount: '{count} 位参与者',
    noParticipants: '暂无参与者',
    total: '总计',
    noIntroYet: '暂未介绍',
    editIntro: '编辑介绍',
    teammatesIntros: '队友的介绍',
  },
  intro: {
    record: '录制',
    stop: '停止',
    play: '播放',
    reRecord: '重新录制',
    recordingUnsupported: '当前浏览器不支持录音功能。',
    recordingError: '无法访问麦克风。请检查权限设置。',
    hint: '建议时长：10-30秒',
  },
  phaseNav: {
    title: '阶段',
    expand: '展开阶段',
    collapse: '折叠阶段',
    currentPhase: '当前阶段',
    viewingPhase: '查看阶段',
    viewingPast: '查看过去',
    backToCurrent: '返回当前',
    goToCurrent: '前往当前阶段',
  },
  phase4: {
    title: '技术导引',
    subtitle: '设置AI图像生成工具',
    sections: {
      login: '账号登录',
      apiKey: '创建API密钥',
      mcp: 'MCP广场开通',
      config: '配置',
      test: '测试',
    },
    navigation: {
      previous: '上一步',
      next: '下一步',
      complete: '完成',
      step: '步骤',
    },
    actions: {
      zoomIn: '放大',
      zoomOut: '缩小',
      copyCode: '复制代码',
      close: '关闭',
    },
    tips: {
      clickToZoom: '点击图片放大',
      useArrowKeys: '使用方向键导航',
    },
    completion: {
      title: '设置完成！',
      message: '您现在可以在工作坊中使用AI图像生成了。',
    },
  },
  phase5: {
    title: '互动实践',
    subtitle: '与团队一起练习口述影像',
    instructionsTitle: '练习说明',
    instructionsText: '与团队成员合作练习描述素材。口述者观察并描述，而AI操作员根据描述生成图像。',
    tips: {
      title: '优秀口述影像的技巧',
      tip1: '首先关注最重要的视觉元素',
      tip2: '使用清晰、简洁的语言创造心理画面',
      tip3: '描述动作、颜色、位置和相互关系',
    },
  },
  phase6: {
    title: '作品创作',
    subtitle: '借助AI辅助创作口述影像作品',
  },
  videoMaker: {
    title: '视频制作',
    openMaker: '创建视频',
    phase5Reminder: '使用AI生成的图片和视频，或在那里生成更多',
    goToPhase5: '前往AI生成',
    mediaLibrary: '媒体库',
    timeline: '时间轴',
    duration: '时长',
    maxDuration: '最长60秒',
    addMedia: '添加',
    addAudio: '添加音频',
    audioOverlay: '音频覆盖',
    replaceAudio: '替换原声',
    preview: '预览',
    play: '播放',
    pause: '暂停',
    export: '导出视频',
    exporting: '导出中...',
    exportSuccess: '视频导出成功',
    exportError: '视频导出失败',
    noContent: '暂无内容',
    emptyLibrary: '暂无AI生成内容',
    trimStart: '起始裁剪',
    trimEnd: '结束裁剪',
    removeTrack: '移除',
    seconds: '秒',
    remaining: '剩余',
    images: '图片',
    videos: '视频',
    video: '视频',
    tracks: '轨道',
    format: '格式',
    download: '下载',
    exportHint: '导出为WebM格式',
    noAudio: '无音频覆盖',
    clearAudio: '清除音频',
    audioDuration: '音频时长',
    chooseAudio: '选择音频文件',
    supportedFormats: '支持MP3、WAV、OGG格式',
    upload: '上传',
    record: '录音',
    recordedAudio: '录制的音频',
    invalidAudioFile: '请选择有效的音频文件',
    audioLoadError: '音频文件加载失败',
    aiImages: 'AI图片',
    aiVideos: 'AI视频',
    uploadedImages: '拍摄照片',
    uploadedVideos: '上传视频',
  },
  errors: {
    sessionNotFound: '未找到工作坊会话',
    sessionEnded: '此工作坊已结束',
    invalidCode: '无效的工作坊代码',
    invalidCredentials: '邮箱或密码无效',
    invalidPassword: '密码无效',
    nicknameRequired: '昵称为必填项',
    networkError: '网络错误，请重试',
    authRequired: '请先登录',
    authFailed: '认证失败',
    quotaExceeded: '生成配额已超限',
    joinFailed: '加入工作坊失败',
    noTeamAssigned: '您尚未被分配到团队',
    pageNotFound: '页面未找到',
    pageNotFoundHint: '您要查找的页面不存在。',
    passwordMismatch: '两次密码不一致',
    workshopNameRequired: '工作坊名称为必填项',
    passwordRequired: '密码为必填项',
    createFailed: '创建工作坊失败',
    adminRequired: '需要管理员权限',
    emailAlreadyExists: '该邮箱已被注册',
    passwordTooShort: '密码太短，至少需要6个字符',
    publishFailed: '发布工作坊失败',
    uploadFailed: '文件上传失败',
  },
  session: {
    accessControls: '访问控制',
    archive: '归档',
    unarchive: '取消归档',
    hide: '隐藏',
    unhide: '取消隐藏',
    archiveTitle: '归档会话',
    archiveDesc: '归档后所有人都无法修改',
    hideTitle: '隐藏会话',
    hideDesc: '隐藏后仅主持人可修改',
    archivedMessage: '此会话已归档，无法进行任何更改。',
    hiddenMessage: '此会话处于仅主持人模式，只有主持人可以进行更改。',
  },
  approval: {
    modeTitle: '需要审批',
    modeDesc: '启用后，新参与者需要主持人批准才能加入',
    enabled: '已启用',
    disabled: '已禁用',
    pendingTitle: '待审批',
    pendingUserTitle: '等待审批',
    pendingUserMessage: '您的加入请求已发送给主持人。',
    pendingUserHint: '审批通过后将自动跳转。',
    sessionName: '会话',
    approve: '批准',
    reject: '拒绝',
    rejectedTitle: '请求被拒绝',
    rejectedMessage: '您的加入请求未被主持人批准。',
    goHome: '返回首页',
    retry: '重新请求',
    cancel: '取消',
    unknownUser: '未知用户',
  },
}
